import React, { useState, createContext } from 'react'

interface ICustomFilter {
  children: React.ReactNode
}
export const CustomFilterModalContext = createContext({
  open: false,
  /* eslint-disable @typescript-eslint/no-empty-function */
  handleOpen: () => {},
  handleClose: () => {}
})

export function CustomFilterProvider({ children }: ICustomFilter) {
  const [open, setOpen] = useState(false)

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <CustomFilterModalContext.Provider
      value={{
        handleOpen,
        handleClose,
        open
      }}
    >
      {children}
    </CustomFilterModalContext.Provider>
  )
}
